import { render, staticRenderFns } from "./ChatTemplate.vue?vue&type=template&id=4e6ff11a&scoped=true"
import script from "./ChatTemplate.vue.ts?vue&type=script&lang=ts&external"
export * from "./ChatTemplate.vue.ts?vue&type=script&lang=ts&external"
import style0 from "./ChatTemplate.vue?vue&type=style&index=0&id=4e6ff11a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6ff11a",
  null
  
)

export default component.exports